import { apiSlice } from './apiSlice';
import { SALES_URL } from '../constants';

export const salesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new sale
    createSale: builder.mutation({
      query: (sale) => ({
        url: SALES_URL,
        method: 'POST',
        body: sale,
      }),
    }),
    // Get sale details by ID
    getSaleDetails: builder.query({
      query: (id) => ({
        url: `${SALES_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get logged-in user's sales
    getMySales: builder.query({
      query: () => ({
        url: `${SALES_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get all sales (Admin view)
    getSales: builder.query({
      query: () => ({
        url: SALES_URL,
      }),
      keepUnusedDataFor: 5,
    }),
    // Mark a sale as delivered (Admin action)
    deliverSale: builder.mutation({
      query: (saleId) => ({
        url: `${SALES_URL}/${saleId}/deliver`,
        method: 'PUT',
      }),
    }),
    // Delete a sale (Admin action)
    deleteSale: builder.mutation({
      query: (saleId) => ({
        url: `${SALES_URL}/${saleId}`,
        method: 'DELETE',
      }),
    }),
    // Update a sale
    updateSale: builder.mutation({
      query: ({ saleId, updatedSale }) => ({
        url: `${SALES_URL}/${saleId}`,
        method: 'PUT',
        body: updatedSale,
      }),
    }),
  }),
});

export const {
  useCreateSaleMutation,
  useGetSaleDetailsQuery,
  useGetMySalesQuery,
  useGetSalesQuery,
  useDeliverSaleMutation,
  useDeleteSaleMutation,
  useUpdateSaleMutation, // Newly added export
} = salesApiSlice;